var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 704,
    height: 336,
    viewBox: "0 0 704 336",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2026_46740)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 704,
    height: 336,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.7072 290.061C7.79457 264.533 -152.016 -15.3758 -94.0001 -19.9997C-21.4803 -25.7796 -12.5084 -3.76234 55.9999 52.0002C228 192 203.09 172.239 286 216C391.486 271.678 700.118 262.96 715.425 168.138C715.609 160.157 715.739 155.489 715.739 155.489C716.198 159.864 716.08 164.08 715.425 168.138C714.676 200.615 713.044 287.964 715.739 339H0.613976L-15.7072 290.061Z",
    fill: "#DADFBE",
    fillOpacity: 0.260417
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2026_46740"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 704,
    height: 336,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage6);
export default __webpack_public_path__ + "static/media/image6.d1c6f6524568fa6689a72798318bd318.svg";
export { ForwardRef as ReactComponent };